"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  interestedParties: {
    tips: {
      AuthoritySuccess: 'Assignment of permissions succeeded',
      bankInfoUpdateSuccess: 'Bank Info Update Success',
      pleaseFill: 'Please complete the form data!',
      pleaseSave: 'Please save the data',
      abandonSuccess: 'Abandoned successfully',
      abandonFail: 'Abandoned Unsuccessfully',
      notSelf: 'Subordinate approvers cannot choose themselves',
      pleaseRefuseNode: 'Please select a rejection node',
      notNull: 'Approval comments cannot be empty',
      selectNext: 'Please select the next approver',
      serviceCode: 'Service code already exists',
      serviceName: 'The Chinese name of the service type already exists',
      serviceNameEn: 'English name of service type already exists',
      selectOne: 'Please select a record',
      noAuthority: 'No permission',
      had2black: 'The supplier has been added to the blacklist and cannot be evaluated',
      hadEvaluate: 'The data has been evaluated, please do not delete!',
      hadEvaluatIng: 'The data is being evaluated, please do not delete!',
      blackTip: 'Are you sure to join the blacklist?',
      blackSuccess: 'Successfully pulled black',
      blackFaill: 'Blackout failed, please try again!',
      updateSuccess: 'Update completed',
      updateFail: 'Update Fail',
      notNullFillTable: 'Can not be empty, please complete the form',
      shouldBe11: 'should be 11 digits, if less than 11 digits, you will be prompted to fill in XXX',
      noLowChar: 'must not contain lowercase letters',
      containIllegalChar: 'contains illegal characters:',
      noNullAndNoLowChar: 'cannot be empty and can not use lowercase letters',
      messageMore: 'The initial evaluation of the data is not completed, unqualified, or the current department has no authority for the time being, and regular evaluation is not possible!',
      selectNew: 'Please select a new supplier record',
      selectMore: 'Please select At Least One',
      onlyDel: 'Can only delete appended records',
      sendSuccess: 'send successful',
      sendFail: 'fail in send',
      conditionIsNotMet: 'The sending condition is not met',
      repeatEval: 'The current department has already assessed, please do not repeat the assessment!',
      BankInfoUpdateSuccess: 'Bank Info Update Success',
      BankInfoUpdateFail: 'Bank Info Update Fail',
      chooseRateYear: 'Please choose Rate Year',
      disableSupplierSuccess: 'Disable Supplier Success',
      disableSupplierFail: 'Disable Supplier Fail',
      disableSupplier: 'Disable Supplier'
    },
    common: {
      relatedParties: 'Interested Party Management',
      option: 'Operation',
      pleaseEnter: 'Please Enter',
      pleaseEnterEvalBasis: 'Please Enter EvalBasis',
      pleaseChoose: 'Please Choose',
      chooseDate: 'Choose Date',
      qualificationType: 'Qualification Type',
      qualificationName: 'Qualification Name',
      expireTime: 'Expire Time',
      startChange: 'Start Change',
      saveUnimportance: 'Save Unimportance Message',
      checkoutButton: 'Check Rip Exist',
      tip1: 'To avoid adding an existing supplier, please check whether the supplier already exists according to the following steps before adding:',
      tip2: 'Step 1: enter the planned new supplier information in the query area, and then click "check whether it exists". At this time, the data of "company" and "other records" will be displayed in the system according to the current company and other conditions.',
      tip3: 'Step 2: according to the data displayed by the system and the actual needs, judge whether it already exists in the library in the following tab',
      tip4: '1. "Current company": if the supplier you are looking for is displayed in this tab page, it means that this supplier has been used in this company and does not need to be added.',
      tip5: '2. "Other companies": "current company" cannot be found, please go to the "other companies" tab page to query whether it exists. If it exists, it means that this supplier exists in the imp library, but is only used by other companies. Please check this supplier, then click the "authorization" button at the top right, and then use it after initial evaluation.',
      tip6: '3. "Master data": if the master data already exists, please check the "add" button in the upper right corner for initial evaluation',
      tip7: '4. If it does not exist, please click add directly on the master data page (unchecked)'
    },
    // 供应商管理
    supplierManage: {
      dutyOffice: 'Duty Office',
      companyName: 'Company Name',
      ripStatus: 'Supplier Status',
      supplierCustomer: 'Supplier/Customer',
      applicantCompany: 'Applicant company',
      bankStatus: 'Bank Status',
      exportFile: 'Export File',
      supplier: 'Supplier Management',
      airPreparationCode: 'Main Data Code',
      serviceTypes: 'Service Types',
      supplierCode: 'Code',
      supplierName: 'Name',
      initialAssessment: 'Initial Assessment',
      regularAssessment: 'Regular Assessment',
      supplierNameEn: 'Supplier EnName',
      abbreviation: 'Abbreviation',
      countryRegion: 'Country Region',
      inOutGroup: 'Group Type',
      initialEvalDate: 'InitialEval Date',
      masterDataStatus: 'Master Data Status',
      updateStatus: 'is updating',
      yes: 'yes',
      no: 'no',
      inGroup: 'Within the Group',
      outGroup: 'Outside the Group',
      serviceType: 'Service Type',
      dept: 'Dept',
      sendPlatform: 'Send to Master Data Platform',
      authorityAssignment: 'Authority Assignment',
      handleCheckBankInfoFromMasterData: 'Check Bank Info',
      disableBankCard: 'Disable',
      startBankCard: 'Start Up',
      blacklist: 'Black List',
      baseInfo: 'Base Info',
      companyContactsInfo: 'Company Contacts Info',
      supplierCnName: 'Supplier Cn Name',
      supplierEnName: 'Supplier En Name',
      supplierAbbreviation: 'Supplier Abbreviation',
      supplierCode2: 'Supplier Code',
      isFormal: 'Formal',
      newDepartments: 'Add Department',
      uniSoCreditCode: 'Uniform Social Credit Code / Business Register NO',
      tips: 'Domestic natural persons fill in the ID number, domestic enterprises fill in the unified social credit code, overseas natural persons fill in the passport number, overseas enterprises fill in the D&B code, except Hong Kong, Hong Kong enterprises fill in the business registration certificate',
      city: 'City',
      registeredCurrency: 'Registered Currency',
      groupEnterpriseNature: 'Group Enterprise Nature',
      beforeName: 'Before Name',
      isStrategy: 'Group Strategic Customers',
      isListed: 'is Listed',
      isSupplier: 'is Supplier',
      isCustomer: 'is Customer',
      industryClassification: 'Industry Classification',
      partnerType: 'Partner Type',
      province: 'Province',
      redAddress: 'The Registered Address',
      redAddressEn: 'The Registered Address EN',
      regDt: 'The Registration Date',
      regPerson: 'Legal Representative',
      regMoney: 'The Registered Capital',
      bizStatus: 'Enterprise State',
      companyEmail: 'Contact Email',
      companyTelephone: 'Contact Phone Number',
      companyOtherPhone: 'The Other Phone',
      industry: 'Industry',
      corporateCode: 'Corporate Code',
      parentCode: 'parent Code',
      stockCode: 'Stock Code',
      supplierNature: 'Supplier Nature',
      providedProServices: 'Provided Services',
      contacts: 'Contacts',
      applicableDept: 'Applicable Dept',
      contactNum: 'Telephone',
      contactDept: 'Contact Dept',
      phone: 'Phone',
      email: 'Postcode',
      fax: 'Fax',
      emailAdrs: 'E-mail',
      contactAdrs: 'Contact Address',
      bankAcount: 'Bank Account',
      payType: 'Pay Type',
      auditStatus: 'Audit Status',
      payeeName: 'Payee',
      payeeAddress: 'Payee Address',
      payeeBank: 'Payee Bank',
      bankNo: 'Bank NO',
      bankOther: 'Bank Other',
      bankCode: 'HK BANK CODE',
      currency: 'Currency',
      bankAdrs: 'Bank Address',
      payeeAcount: 'Payee Account',
      bankCheckFiles: 'Bank Review Attachment',
      bankCheckFilesAndBlackListCheckFile: 'Bank Review Attachment & Blacklist Decision Doc.',
      swiftCode: 'Swift Code',
      agentBankName: 'Agent Bank Name',
      agentAddress: 'Agent Bank Address',
      agentBankAcount: 'Agent Bank Account',
      agentCountryRegion: 'Agent Country Region',
      agentBankSwiftCode: 'Agent Bank Swift Code',
      company: 'Company',
      applicableCompany: 'Applicable Company',
      status: 'Status',
      shipName: 'Vessel Name',
      businessType: 'Business Type',
      financeStatus: 'Finance Status',
      orderNo: 'Order No',
      orderDate: 'Order Date',
      originalAmount: 'Original Amount',
      localAmount: 'Base Amount',
      rate: 'Rate',
      ratePeople: 'Rater',
      rateDate: 'Rate Date',
      rateYear: 'Rate Year',
      evaluationTimes: 'Evaluation Times',
      evaluationAverage: 'Evaluation Average',
      evaluationGrade: 'Evaluation Grade',
      moreThan: 'More Than 3 Point Times',
      below: 'Below 3 Point Times',
      conclusion: 'Conclusion',
      remark: 'Remark',
      qualificationMaterials: 'Qualification Materials',
      notNull: 'Not Null',
      lowercaseLettersCannotExist: 'lowercase Letters Cannot Exist in nameCn',
      assessed: 'Assessed',
      notEvaluated: 'Not Evaluated',
      supplierDetails: 'Supplier Details',
      historyOrder: 'History Order Evaluation',
      annualAssessment: 'Annual Assessment',
      annualAssessmentInit: 'Annual Assessment Init',
      annualAssessmentAnnual: 'Annual Assessment Annual',
      currentCompany: 'Current Company',
      otherCompany: 'Other Company',
      mainData: 'Main Data',
      evaluationDept: 'Department',
      evaluationDate: 'Date',
      evaluationPeople: 'Evaluator(s)',
      relatedName: 'Related Name',
      relatedPeolple: 'Name of Contact Person',
      telephone: 'Tel',
      officeAddress: 'Office’s Address',
      evaluationType: 'Kind of Evaluation',
      evaluationYear: 'Year of Evaluation',
      evaluationMethods: 'Method of Evaluation',
      evaluationBasis: 'Basis of Evaluation',
      relatedNature: 'Nature of Interested Party',
      qualifications: 'Qualification',
      industryReputation: 'Industry Reputation',
      screeningResults: 'Screening Results',
      relatedExpectations: 'Related Expectations',
      briefIntroduction: 'Brief Introduction',
      evaluators: 'Evaluators',
      qualification: 'Qualification',
      creditability: 'Reputation',
      afterSalesService: 'After Sales Service',
      serviceQuality: 'Service Quality',
      price: 'Reasonable Price',
      timelinessOfQuotation: 'Timeliness of Quotation',
      stockingDeliveryTimeliness: 'Stocking/delivery timeliness',
      cmgBlacklistCheckResult: 'Yes or No on blacklisted supplier of CMG',
      domesticIntegrityAuditResult: 'integrity audit',
      foreignCompanyCreditReviewResults: 'Foreign company credit review results',
      economicSanctionsComplianceScreening: 'Economic sanctions compliance screening',
      unqualifiedReason: 'unqualified Reason',
      durationOfDiscontinuation: 'duration Of Discontinuation',
      relatedPrvdProSer: 'Main Products or Service of Interested Parties',
      relatedTeam: 'Management Team',
      cooperationPerformance: 'The Cooperation Performance Past 12 Months',
      improvement: 'Expectation to Be Improved',
      evaluationconclusion: 'Conclusion',
      qualificationsMsg: 'Qualifications Msg',
      notApplicable: 'Not Applicable',
      noNeedCheck: 'Not Send to master, No Need Check',
      UpperCaseLetters: 'Can only contain uppercase letters',
      changeTypeToSupplier: 'Change Type to Supplier',
      notNumberInfo: 'Please enter a number, keeping up to two decimal places'
    },
    // 定期评估
    timeAssessment: {
      regularAssessment: 'Regular Assessment',
      assessmentYear: 'Assessment Year',
      submitter: 'Submitter',
      auditStatus: 'Audit Status',
      remark: 'Remark',
      assessmentDept: 'Assessment Dept',
      annualSummary: 'Annual Summary',
      statisticalSummary: 'Statistical Summary',
      additionalSuppliers: 'Additional Suppliers',
      supplierMsg: 'Supplier Msg',
      resultsEditing: 'Results Editing',
      additional: 'Additional',
      businessAssessment: 'Business Assessment',
      ship: 'Vessel',
      businessOrderNo: 'Business Order No',
      afterSaleService: 'After Sale Service',
      quotation: 'Quotation',
      priceRationality: 'Price Rationality',
      goodsWorkQuality: 'Goods Work Quality',
      goodsPreDis: 'goods Pre Dis',
      totalScore: 'Total Score',
      rater: 'Rater',
      rateDate: 'Rate Date',
      spare: 'Spare'
    },
    // 其他相关方管理
    otherPartiesManage: {
      otherParties: 'Other Interested Party Management',
      relatedCode: 'Related Code',
      relatedNameCn: 'Related Name Cn',
      relatedNameEn: 'Related Name En',
      relatedAbbreviation: 'Related Abbreviation',
      relatedCode2: 'Related Code',
      prvdProSer: 'Prvd Pro Ser',
      team: 'Team',
      evaluationStatus: 'Evaluation Status',
      hasSend: 'Send',
      hasConfirm: 'Confirm',
      noPass: 'Un pass',
      otherDetail: 'Other Detail',
      evaluationHistory: 'Evaluation History',
      changeVersion: 'Change Version'
    },
    // 相关方评估监控
    evaluationMonitor: {
      Refreshmonitoringdata: 'Refresh monitoring data',
      monitorYear: 'Evaluation year',
      eMonitor: 'Interested Party Evaluation Monitor',
      pleaseChooseYear: 'Please Choose Year',
      otherRealted: 'Relevant Party',
      allState: 'All Status',
      assessed: 'Assessed',
      underAssessed: 'Assessing',
      notEvaluated: 'Not Assesse',
      supplier: 'Supplier',
      year: 'Year',
      annualSummary: 'Annual Summary',
      periodicEvaluation: 'Periodic Evaluation',
      realtedType: 'Realted Type',
      team: 'Team',
      evaluationPeople2: 'Evaluation People'
    },
    // 评估频率配置
    frequencyConfig: {
      config: 'Config',
      filterSearch: 'Search',
      evalDeptName: 'Eval Dept Name',
      cooperationType: 'Cooperation Type',
      serviceCode: 'Service Code',
      serviceTypeCn: 'Service Type Cn',
      serviceType: 'Service Type',
      evalFrequency: 'Eval Frequency',
      configStatus: 'Config Status'
    },
    /* 相关方申请修改 */
    interstedModify: {
      interstedModify: 'Intersted Modify',
      applyPerson: 'Apply Person',
      applyDept: 'Apply Dept',
      nameCn: 'Name Cn',
      nameEn: 'Name En',
      applyStatus: 'Apply Status',
      applyTime: 'Apply Time',
      isSendMainData: 'Main Data Status',
      operation: 'Operation',
      importantMsgModify: 'Important Msg Modify',
      modifyReason: 'Modify Reason',
      historyVersion: 'Version',
      initialAssessmentStatus: 'Initialassessment Status',
      supplierStatus: 'Supplier Status',
      mainDataReason: 'Main Data Reason',
      changeData: 'Interstedmodify ',
      nextApprover: 'Next Approver'
    },
    ripType: {
      ripType: 'RipType',
      supplier: 'Supplier',
      customer: 'Customer',
      others: 'Others',
      supplierCustomer: 'Supplier / Customer',
      supplierOthers: 'Supplier / Others',
      customerOthers: 'Customer / Others',
      supplierCustomerOthers: 'Supplier / Customer / Others'
    }
  }
};